export interface PermissionsState {
  givenPermissionsSent: any[];
  givenPermissionsGrant:any[];
  receivedPermissionsSent: any[];
  receivedPermissionsGrant:any[];
  }
  
  export const initialState: PermissionsState = {
    givenPermissionsSent: null,
    givenPermissionsGrant:null,
    receivedPermissionsSent: null,
    receivedPermissionsGrant:null
  };
  